import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { text: string }) { }

  text: string;

  ngOnInit(): void {
    if (this.data.text)
      this.text = this.data.text;
    else
      this.text = "Loading";
  }

}
